import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';

export const BetaChip = () => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t('BETA')}
      size="small"
      data-test="nav-beta-chip"
      sx={{
        height: 20,
        margin: theme => theme.spacing(0, 0, 0, 1),
        padding: theme => theme.spacing(1, 1.5),
        backgroundColor: theme => theme.palette.primary.light,
        color: theme => theme.palette.primary.main,
        verticalAlign: 'middle',
        '& .MuiChip-label': {
          padding: 0,
        },
        '&:hover': {
          backgroundColor: theme => theme.palette.primary.light,
        },
      }}
    />
  );
};
